import { useEffect } from 'react'

/**
 * Custom hook that triggers a callback when an element becomes visible in the viewport.
 * after a certain threshold (default is 95%).
 *
 * once the callback is triggered, the observer will disconnect if `once` is true.
 */
export function useOnVisible({
  ref,
  onVisible,
  threshold = 0.95,
  once = true,
}: {
  ref: React.RefObject<Element>
  onVisible: () => void
  threshold?: number
  once?: boolean
}) {
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          onVisible()
          if (once) observer.disconnect()
        }
      },
      { threshold }
    )

    if (ref.current) observer.observe(ref.current)
    return () => observer.disconnect()
  }, [ref, onVisible, threshold, once])
}
